import axios, { type AxiosError } from 'axios'

import { SUCCESS_CODE } from '@/core/types/envelope'

export type TEnvelopeError = {
  code?: string
  message?: string
  args?: string[]
  detail?: Array<{ loc: Array<string | number>; msg: string; type: string }>
  details?: Array<{ field: string; message: string; type: string }>
}

export const isAxios = (err: unknown): err is AxiosError<TEnvelopeError> =>
  axios.isAxiosError(err)

export const getEnvelope = (err: unknown): TEnvelopeError | undefined =>
  isAxios(err) ? (err.response?.data as TEnvelopeError | undefined) : undefined

export const getCode = (err: unknown): string | undefined => {
  const env = getEnvelope(err)
  return typeof env?.code === 'string' ? env.code : undefined
}

export const getMessage = (err: unknown, fallback: string): string => {
  const env = getEnvelope(err)
  if (typeof env?.message === 'string') return env.message
  if (err instanceof Error && err.message) return err.message
  return fallback
}

export const isSuccessCode = (code: string | undefined): boolean =>
  code === SUCCESS_CODE
